import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  title: () => faker.lorem.sentence(),
  sortable: false,

  asWelcomeSubject: trait({
    title: 'Subject',
    sortable: false,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withDynamicString', 'asNotDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Email subject line' }),
        mailerSection,
      });
    },
  }),

  asWelcomeConditions: trait({
    title: null,
    sortable: false,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withDropdown', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Conditions' }),
        mailerSection,
      });
    },
  }),

  asWelcomeHeader: trait({
    title: 'Header',
    sortable: false,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Logo' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withDynamicString', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Header' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withDynamicString', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Sub header' }),
        mailerSection,
      });
    },
  }),

  asWelcomeBody: trait({
    title: 'Body',
    sortable: true,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Welcome guide' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Earned a stamp' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withHtml', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Custom content' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withDropdown', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Legal documents' }),
        mailerSection,
      });
    },
  }),

  asInviteSubject: trait({
    title: 'Subject',
    sortable: false,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withDynamicString', 'asNotDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Email subject line' }),
        mailerSection,
      });
    },
  }),

  asInviteHeader: trait({
    title: 'Header',
    sortable: false,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Logo' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withDynamicString', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Header' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withDynamicString', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Subheader' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Visit details' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withAddress', 'withDirections', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Address' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: '"Add to calendar" link' }),
        mailerSection,
      });
    },
  }),

  asInviteBody: trait({
    title: 'Body',
    sortable: true,
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Registration link' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Invite QR code' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Touchless sign-in' }),
        mailerSection,
      });
      server.create('mailer-section-block', 'withHtml', 'asDeactivatable', {
        mailerBlock: server.create('mailer-block', { title: 'Custom content' }),
        mailerSection,
      });
    },
  }),

  // too many tests tied to the shape of this data to change
  withBlocks: trait({
    afterCreate(mailerSection, server) {
      server.create('mailer-section-block', 'withImmutableText', 'asDeactivatable', {
        mailerSection,
      });

      server.create('mailer-section-block', 'withString', 'withCheckbox', 'asDeactivatable', {
        mailerSection,
      });

      server.create('mailer-section-block', 'withHtml', 'asDeactivatable', {
        mailerSection,
      });

      server.create('mailer-section-block', 'withDynamicString', 'asNotDeactivatable', {
        mailerSection,
      });
    },
  }),
});
